import script from "./PasswordReset.vue?vue&type=script&setup=true&lang=js"
export * from "./PasswordReset.vue?vue&type=script&setup=true&lang=js"

import "./PasswordReset.vue?vue&type=style&index=0&id=14e6e6ce&scoped=true&lang=css"

import exportComponent from "/Users/damon/workspace/authweb/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-14e6e6ce"]])

export default __exports__